import Decimal from 'decimal.js-light'

export class UtilsService {
  // не точное преобразование в число (присовершении математических операций возможна погрешность),
  // предпочтительнее использовать toDecimal
  static toNumber(value: string | number | undefined): number {
    if (value === undefined) return 0
    if (typeof value === 'number') return value
    return parseFloat(value)
  }

  static toDecimal(value: string | number | undefined, fallback = 0): Decimal {
    if (value === undefined) return new Decimal(fallback)
    if (typeof value === 'number') return new Decimal(value)
    return new Decimal(value)
  }
}